module.exports = __webpack_public_path__ + "img/logo-small.35d595b5.png";